/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import './dashboard.scss'

import Menu from '../../components/Menu'
import LineChart from '../../components/Chart/LineChart'

import resturant from '../../assets/svg/resturant.svg'
import category from '../../assets/svg/category.svg'
import food from '../../assets/svg/food.svg'
import bg from '../../assets/svg/bg.svg'
import CustomerClub from '../../assets/svg/CustomerClub.svg'
import menuInside from '../../assets/svg/MenuInside.svg'
import peykIcon from '../../assets/svg/Peyk.svg'

import qr from '../../assets/svg/qr.svg'

import { ToRial } from '../../services/toRial'

import { UserDate } from '../../Data'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { get } from '../../services/http'

export default function index() {
  const navigate = useNavigate()
  // eslint-disable-next-line no-unused-vars
  const [orderWeek, setOrderWeek] = useState([])
  const [saleOrder, setSaleOrder] = useState(0)
  const [saleCount, setSaleCount] = useState(0)
  const [userCount, setUserCount] = useState(0)
  const [allOrders, setAllOrders] = useState(0)
  const [allSale, setAllSale] = useState(0)
  const [creditFarazSms, setCreditFarazSms] = useState(0)
  // eslint-disable-next-line no-unused-vars
  const [creditLiara, setCreditLiara] = useState(0)

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/dashboard?token=${token}`,).then(response => {
      setOrderWeek(response.data.data.weeklySale)
      setSaleOrder(response.data.data.monthlySale)
      setSaleCount(response.data.data.ordersCount)
      setUserCount(response.data.data.users)
      setAllOrders(response.data.data.allOrdersCount)
      setAllSale(response.data.data.allSale)

      setChartData({ labels: response.data.data.dateWeek.labels, 
        datasets: response.data.data.dateWeek.datasets
      })
    })

    get(`/api/admin/getFarazSmsCredit?token=${token}`).then(response => {
      setCreditFarazSms(response.data.data[1])
    })

    // const config = {
    //   headers: {
    //     'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySUQiOiI2MDNiZTZkMGNhZmIyODAwMTE5N2ZkODQiLCJ0eXBlIjoiYXV0aCIsImlhdCI6MTc1MDkyMjU3NH0.im2adNpeG9BzFM6RlsSE_K0x150IHalXUOQ4fxnqyA8'
    //   }
    // }

    // getPure(`https://api.liara.ir/v1/billing`, config).then(response => {
    //   console.log(response)
    //   setCreditLiara(response.data.user.balance)
    // })
  }, [token])

  // eslint-disable-next-line no-unused-vars
  const [chartData, setChartData] = useState({
    labels: UserDate.map((data) => data.yaer),
    datasets: [
      {
        label: 'فروش هفتگی',
        data: UserDate.map((data) => data.userGain),
        backgroundColor: ['#1B629D'],
      },
    ],
  })

  document.title = 'داشبورد'

  return (
    <main id='dashboard'>
      <Menu page={'dashboard'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='dashboardBody'>
        <section className='dashboardContent'>
          <div className='analytics'>
            <div className="moduleTitle">
              ماژول‌ها
            </div>
          </div>
          <div className="modules">
            <Link to='/customerClub'>
              <img src={CustomerClub} alt="CustomerClub" />
              <hr />
              <section className='modulesText'>
                باشگاه مشتریان 
              </section>
            </Link>
            <Link to='/internalMenu'>
              <img src={menuInside} alt="menuInside" />
              <hr />
              <section className='modulesText'>
                منو داخلی
              </section>
            </Link>
            <Link to='/peyk'>
              <img src={peykIcon} alt="peykIcon" />
              <hr />
              <section className='modulesText'>
                مدیریت پیک
              </section>
            </Link>
          </div>

          <div className='analytics'>
            <div className="moduleTitle">
              مانده حساب های کاربری
            </div>
          </div>

          <div className="statistics">
            <div className='card'>
              <div className='title'>
                میزان شارژ فراز اس ام اس :
              </div>
              <div className='value'>
                {ToRial(String(Math.floor(creditFarazSms) / 10))} تومان
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                میزان شارژ ابرآروان :
              </div>
              <div className='value'>
                {/* {ToRial(String(Math.floor(creditLiara)))} تومان */}
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                
              </div>
              <div className='value'>
                
              </div>
            </div>
          </div>

          <div className='analytics'>
            <div className="moduleTitle">
              آمار
            </div>
          </div>

          <div className="statistics">
            <div className='card'>
              <div className='title'>
                میزان فروش کل :
              </div>
              <div className='value'>
                {ToRial(String(allSale))} تومان
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد فروش کل :
              </div>
              <div className='value'>
                {allOrders} عدد
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد کاربران :
              </div>
              <div className='value'>
                {userCount} نفر
              </div>
            </div>
          </div>

          <div className='analytics'>
            <div className='qrSection'>
              <div className='text'>
                <span>کیوآرکد</span>
                <span>QR Code</span>
              </div>
              <hr />
              <div className='qr'>
                <img src={qr} alt='qr' />
              </div>
              <hr />
              <div className='suggestText'>
                با استفاده از دوربین خود اسکن کنید
              </div>
            </div>
            <div className='lineChart'>
              <span> فروش هفتگی : {ToRial(String(orderWeek))} تومان</span>
              <LineChart chartData={chartData} />
            </div>
          </div>

          <div className='crateSection'>
            <div className='resturant'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={resturant} alt='resturant' />
                <section className='text'>
                  <span>قدم اول</span> : ایجاد رستوران
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/resturants/create')}>
                  ایجاد
                </button>
                <Link to='/resturants' className='outlineLink'>
                  لیست رستوران‌ها
                </Link>
              </div>
            </div>
            <div className='category'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={category} alt='category' />
                <section className='text'>
                  <span>قدم دوم</span> : ایجاد دسته بندی
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/categories/create')}>
                  ایجاد
                </button>
                <Link to='/categories' className='outlineLink'>
                  لیست دسته بندی‌ها
                </Link>
              </div>
            </div>
            <div className='food'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={food} alt='food' />
                <section className='text'>
                  <span>قدم سوم</span> : ایجاد غذا یا نوشیدنی
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/foods/create')}>
                  ایجاد
                </button>
                <Link to='/foods' className='outlineLink'>
                  لیست غذا و نوشیدنی
                </Link>
              </div>
            </div>
          </div>

          <div className="statistics">
            <div className='card'>
              <div className='title'>
                میزان فروش ماهانه :
              </div>
              <div className='value'>
                {ToRial(String(saleOrder))} تومان
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد فروش ماهانه :
              </div>
              <div className='value'>
                {saleCount} عدد
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد کاربران :
              </div>
              <div className='value'>
                {userCount} نفر
              </div>
            </div>
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
